import { render, staticRenderFns } from "./OrganizationPeerGroupMember.vue?vue&type=template&id=0e663d72&scoped=true&"
import script from "./OrganizationPeerGroupMember.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPeerGroupMember.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationPeerGroupMember.vue?vue&type=style&index=0&id=0e663d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e663d72",
  null
  
)

export default component.exports